import { useState, useCallback } from 'react';
export const useModal = (openState = false, callbacks) => {
    const [isOpen, setOpenModal] = useState(() => openState);
    const openModal = useCallback((event) => {
        if (callbacks === null || callbacks === void 0 ? void 0 : callbacks.openModalCb) {
            callbacks === null || callbacks === void 0 ? void 0 : callbacks.openModalCb(event);
        }
        setOpenModal(true);
    }, [callbacks]);
    const closeModal = useCallback((event) => {
        if (callbacks === null || callbacks === void 0 ? void 0 : callbacks.closeModalCb) {
            callbacks === null || callbacks === void 0 ? void 0 : callbacks.closeModalCb(event);
        }
        setOpenModal(false);
    }, [callbacks]);
    return { isOpen, openModal, closeModal };
};
